import type { ReactNode } from "react";
import { ZoomIn } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSnak, type RefTarget } from "../snak/SnakContext";
type Props = {
  overline?: ReactNode;
  children: ReactNode;
  /** Small-print evidence context, always visible at the foot of the screen. */
  footnote?: ReactNode;
  /** Optional second footer action, e.g. open an evidence detail. */
  detail?: {
    label: string;
    onClick: () => void;
  };
  refTarget?: RefTarget;
};

/** One Snak screen: overline, editorial body, small-print footer with REFERENCES. */
export function Screen({
  overline,
  children,
  footnote,
  detail,
  refTarget = null
}: Props) {
  const {
    openRefs
  } = useSnak();
  return <div className="mx-auto flex min-h-full w-full max-w-xl flex-col px-6 pb-6 pt-5" data-id="element-220" data-mp="7fcbfozndm3i">
      {overline && <Reveal data-id="element-221" data-mp="2e5ihr83mnujd">
          <p className="overline text-[var(--s-accent)]" data-id="element-222" data-mp="2e73aqtaan5f4">{overline}</p>
        </Reveal>}
      <div className="flex-1" data-id="element-223" data-mp="298a8jx0gj0u9">{children}</div>
      {(footnote || detail) && <Reveal delay={0.45} className="mt-10" data-id="element-224" data-mp="rytzeqbrcd79">
          {footnote && <div className="text-[12.5px] leading-[1.6] text-[var(--s-muted)]" data-id="element-225" data-mp="rwh9nqzrcyjn">{footnote}</div>}
          <div className="mt-4 flex items-center gap-6" data-id="element-226" data-mp="wvarfvm2vbpm">
            <button onClick={() => openRefs(refTarget)} className="overline border-b border-current pb-1 text-[var(--s-muted)] transition-colors duration-150 hover:text-[var(--s-fg)]" data-id="element-227" data-mp="11vgjhcw9f088">
              References
            </button>
            {detail && <button onClick={detail.onClick} className="overline flex items-center gap-1.5 pb-1 text-[var(--s-muted)] transition-colors duration-150 hover:text-[var(--s-fg)]" data-id="element-228" data-mp="1fmv7jy50xrm5">
                <ZoomIn className="h-3.5 w-3.5" strokeWidth={2} data-id="element-229" data-mp="1plax3woekstj" />
                {detail.label}
              </button>}
          </div>
        </Reveal>}
    </div>;
}